<template>
  <div>
    <!-- Skeleton loading state -->
    <b-row align-h="end" class="small" v-if="carregandoParametros">
      <b-col cols="auto">
        <label>{{ $t("label.tipo-periodo") }}</label>
        <b-skeleton width="120px" height="31px"></b-skeleton>
      </b-col>

      <b-col cols="auto" v-if="mostrarDataSkeleton">
        <label>{{ $t("label.data") }}</label>
        <b-skeleton width="120px" height="31px"></b-skeleton>
      </b-col>

      <b-col cols="auto" v-if="mostrarAnoSkeleton">
        <label>{{ $t("label.ano") }}</label>
        <b-skeleton width="120px" height="31px"></b-skeleton>
      </b-col>

      <b-col cols="auto" v-if="mostrarSemanaSkeleton">
        <label>{{ $t("label.semana") }}</label>
        <b-skeleton width="120px" height="31px"></b-skeleton>
      </b-col>

      <b-col cols="auto" v-if="mostrarMesSkeleton">
        <label>{{ $t("label.mes") }}</label>
        <b-skeleton width="120px" height="31px"></b-skeleton>
      </b-col>

      <b-col cols="auto" class="pr-3" v-if="mostrarTurno">
        <label>{{ $t("label.turno") }}</label>
        <b-skeleton width="120px" height="31px"></b-skeleton>
      </b-col>

      <b-col cols="auto" class="pr-3" v-if="mostrarVisualizacao">
        <label>{{ $t("label.visualizacao") }}</label>
        <b-skeleton width="120px" height="31px"></b-skeleton>
      </b-col>
    </b-row>

    <!-- Normal form state -->
    <b-row align-h="end" class="small" v-else>
      <b-col cols="auto">
        <label>{{ $t("label.tipo-periodo") }}</label>
        <b-form-select
          :options="tiposPeridoFiltrado"
          v-model="localTipoPeriodo"
          size="sm"
        ></b-form-select>
      </b-col>

      <b-col cols="auto" v-if="localTipoPeriodo == 1 || localTipoPeriodo == 2">
        <label>{{ $t("label.data") }}</label>
        <b-form-datepicker
          v-model="localData"
          locale="pt-BR"
          size="sm"
          :date-disabled-fn="isDateDisabled"
          :min="minDate"
          :max="maxDate"
        ></b-form-datepicker>
      </b-col>

      <b-col cols="auto" v-if="localTipoPeriodo == 3 || localTipoPeriodo == 4">
        <label>{{ $t("label.ano") }}</label>
        <b-form-select
          class="form-control"
          v-model="localAno"
          :options="anos ? anos.map((a) => ({ value: a, text: a })) : []"
          size="sm"
        ></b-form-select>
      </b-col>

      <b-col cols="auto" v-if="localTipoPeriodo == 3">
        <label>{{ $t("label.semana") }}</label>
        <b-form-select
          class="form-control"
          v-model="localSemana"
          size="sm"
          :options="
            semanasFiltradas
              ? semanasFiltradas.map((s) => ({
                  value: s.semana,
                  text: s.semana,
                }))
              : []
          "
        >
        </b-form-select>
      </b-col>

      <b-col cols="auto" v-if="localTipoPeriodo == 4">
        <label>{{ $t("label.mes") }}</label>
        <b-form-select
          class="form-control"
          v-model="localMes"
          size="sm"
          :options="
            mesesFiltrados
              ? mesesFiltrados.map((m) => ({ value: m.mes, text: m.mes }))
              : []
          "
        >
        </b-form-select>
      </b-col>

      <b-col
        cols="auto"
        class="pr-3"
        v-if="localTipoPeriodo == 1 && mostrarTurno"
      >
        <label>{{ $t("label.turno") }}</label>
        <b-form-select
          v-if="!carregandoTurnos"
          :options="$store.state.turnos"
          v-model="localTurno"
          size="sm"
        ></b-form-select>
        <b-skeleton v-else width="120px" height="31px"></b-skeleton>
      </b-col>

      <b-col cols="auto" class="pr-3" v-if="mostrarVisualizacao">
        <label>{{ $t("label.visualizacao") }}</label>
        <b-form-select
          :options="visualizacoes"
          v-model="localVisualizacao"
          size="sm"
        ></b-form-select>
      </b-col>

      <!-- Botão Aplicar Filtros -->
      <b-col cols="auto" class="d-flex align-items-end">
        <b-button
          variant="secondary"
          size="sm"
          @click="aplicarFiltros"
          :disabled="carregandoParametros || carregandoTurnos"
        >
          {{ $t("button.aplicar-filtros") || "Aplicar Filtros" }}
        </b-button>
      </b-col>
    </b-row>

    <!-- Linha separada para o checkbox Somente com Controle -->
    <b-row align-h="end" class="mt-2" v-if="!carregandoParametros">
      <b-col cols="auto">
        <b-form-checkbox
          v-model="somenteComControle"
          size="sm"
          class="text-muted"
        >
          <small>{{
            $t("label.somente-com-controle") || "Somente com Controle"
          }}</small>
        </b-form-checkbox>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    mostrarTurno: {
      type: Boolean,
      default: false,
    },
    mostrarVisualizacao: {
      type: Boolean,
      default: false,
    },
    relatorio_id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      turnos: [],
      carregandoParametros: false,
      carregandoTurnos: false,
      inicializando: true,
      // Variáveis locais para controlar os filtros antes de aplicar
      localTipoPeriodo: this.$store.state.tipoPeriodo,
      localData: this.$store.state.data,
      localAno: this.$store.state.ano,
      localSemana: this.$store.state.semana,
      localMes: this.$store.state.mes,
      localTurno: this.$store.state.turno,
      localVisualizacao: this.$store.state.visualizacao,
      tiposPeriodo: [
        { value: 1, text: "Turno" },
        { value: 2, text: "Dia" },
        { value: 3, text: "Semana" },
        { value: 4, text: "Mês" },
      ],
      visualizacoes: [
        { value: 1, text: "Porcentagem" },
        { value: 2, text: "Quantidade" },
      ],
    };
  },
  computed: {
    tiposPeridoFiltrado() {
      if (!this.mostrarTurno) {
        return this.tiposPeriodo.filter((tipo) => tipo.value !== 1);
      }
      return this.tiposPeriodo;
    },
    // Computed properties para controlar quando mostrar skeletons específicos
    mostrarDataSkeleton() {
      return this.localTipoPeriodo == 1 || this.localTipoPeriodo == 2;
    },
    mostrarAnoSkeleton() {
      return this.localTipoPeriodo == 3 || this.localTipoPeriodo == 4;
    },
    mostrarSemanaSkeleton() {
      return this.localTipoPeriodo == 3;
    },
    mostrarMesSkeleton() {
      return this.localTipoPeriodo == 4;
    },
    // Computed properties para controle do datepicker
    minDate() {
      if (!this.datas || this.datas.length === 0) {
        return null;
      }
      // Encontra a data mínima no array de datas permitidas
      const sortedDates = [...this.datas].sort();
      return sortedDates[0];
    },
    maxDate() {
      if (!this.datas || this.datas.length === 0) {
        return null;
      }
      // Encontra a data máxima no array de datas permitidas
      const sortedDates = [...this.datas].sort();
      return sortedDates[sortedDates.length - 1];
    },
    turno: {
      get() {
        return this.$store.state.turno;
      },
      set(value) {
        this.$store.commit("setTurno", value);
      },
    },
    data: {
      get() {
        return this.$store.state.data;
      },
      set(value) {
        this.$store.commit("setData", value);
      },
    },
    semana: {
      get() {
        return this.$store.state.semana;
      },
      set(value) {
        this.$store.commit("setSemana", value);
      },
    },
    semanas: {
      get() {
        return this.$store.state.semanas;
      },
      set(value) {
        this.$store.commit("setSemanas", value);
      },
    },
    mes: {
      get() {
        return this.$store.state.mes;
      },
      set(value) {
        this.$store.commit("setMes", value);
      },
    },
    meses: {
      get() {
        return this.$store.state.meses;
      },
      set(value) {
        this.$store.commit("setMeses", value);
      },
    },
    datas: {
      get() {
        return this.$store.state.datas;
      },
      set(value) {
        this.$store.commit("setDatas", value);
      },
    },
    anos: {
      get() {
        return this.$store.state.anos;
      },
      set(value) {
        this.$store.commit("setAnos", value);
      },
    },
    somenteComControle: {
      get() {
        return this.$store.state.somenteComControle;
      },
      set(value) {
        this.$store.commit("setSomenteComControle", value);
      },
    },
    mesesFiltrados() {
      if (!this.meses || !this.localAno) {
        return this.meses;
      }
      // Filtra meses baseado no ano selecionado localmente
      return this.meses.filter((mes) => mes.ano === this.localAno);
    },
    semanasFiltradas() {
      if (!this.semanas || !this.localAno) {
        return this.semanas;
      }

      // Se tipo período é semana (3), filtra por ano e mês se disponível
      let semanasFiltradasLet = this.semanas.filter(
        (semana) => semana.ano === this.localAno
      );

      // Se há um mês selecionado localmente, filtra também por mês
      if (this.localMes) {
        semanasFiltradasLet = semanasFiltradasLet.filter(
          (semana) => semana.mes === this.localMes
        );
      }

      return semanasFiltradasLet;
    },
    primeiroAcessoSelecaoPeriodo: {
      get() {
        return this.$store.state.primeiroAcessoSelecaoPeriodo;
      },
      set(value) {
        this.$store.commit("setPrimeiroAcessoSelecaoPeriodo", value);
      },
    },
  },
  methods: {
    // Método para verificar se uma data deve ser desabilitada no datepicker
    isDateDisabled(ymd) {
      // Se não há datas específicas definidas, permite todas as datas
      if (!this.datas || this.datas.length === 0) {
        return false;
      }

      // Verifica se a data (formato YYYY-MM-DD) está na lista de datas permitidas
      return !this.datas.includes(ymd);
    },
    // Método para aplicar os filtros locais ao store
    aplicarFiltros() {
      this.$store.commit("setTipoPeriodo", this.localTipoPeriodo);
      this.$store.commit("setData", this.localData);
      this.$store.commit("setAno", this.localAno);
      this.$store.commit("setSemana", this.localSemana);
      this.$store.commit("setMes", this.localMes);
      this.$store.commit("setTurno", this.localTurno);
      this.$store.commit("setVisualizacao", this.localVisualizacao);

      // Emite evento para notificar componente pai que os filtros foram aplicados
      this.$emit("filtros-aplicados", {
        tipoPeriodo: this.localTipoPeriodo,
        data: this.localData,
        ano: this.localAno,
        semana: this.localSemana,
        mes: this.localMes,
        turno: this.localTurno,
        visualizacao: this.localVisualizacao,
      });
    },

    carregarTurnos() {
      this.carregandoTurnos = true;
      this.$http
        .get("api/turno")
        .then((response) => {
          this.turnos = [];
          response.data.forEach((element) => {
            this.turnos.push({
              value: element.id,
              text: element.descricao,
            });
          });
          this.$store.state.turnos = this.turnos;
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          this.carregandoTurnos = false;
        });
    },
    carregarParametrosPeriodo() {
      this.carregandoParametros = true;
      let url =
        "api/controles/parametros-periodo?somente-com-controles=" +
        this.somenteComControle;

      // Se relatorio_id foi fornecido, adiciona como parâmetro na URL
      if (this.relatorio_id) {
        url += `&relatorio_id=${this.relatorio_id}`;
      }

      this.$http
        .get(url)
        .then((response) => {
          const data = response.data;

          // Update store with the new data
          this.$store.commit("setAnos", data.anos);
          this.$store.commit("setMeses", data.meses);
          this.$store.commit("setSemanas", data.semanas);
          this.$store.commit("setDatas", data.datas);
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          this.carregandoParametros = false;
        });
    },
  },
  watch: {
    relatorio_id() {
      this.carregarParametrosPeriodo();
    },
    // Watcher para limpar seleções locais quando tipo de período muda
    localTipoPeriodo(novoTipo, tipoAnterior) {
      if (this.inicializando) return;
      if (novoTipo !== tipoAnterior) {
        // Limpa todas as seleções locais quando tipo de período muda
        this.localAno = null;
        this.localMes = null;
        this.localSemana = null;
        this.localData = null;
        this.localTurno = null;
      }
    },
    // Watcher para ano local - limpa mês e semana quando ano muda
    localAno(novoAno, anoAnterior) {
      if (this.inicializando) return;
      if (novoAno !== anoAnterior) {
        // Limpa mês e semana quando ano muda
        this.localMes = null;
        this.localSemana = null;
      }
    },
    // Watcher para mês local - limpa semana quando mês muda
    localMes(novoMes, mesAnterior) {
      if (this.inicializando) return;
      if (novoMes !== mesAnterior) {
        // Limpa semana quando mês muda
        this.localSemana = null;
      }
    },
    somenteComControle() {
      this.carregarParametrosPeriodo();
    },
  },
  mounted() {
    // Verifica se é o primeiro acesso do usuário ao componente
    if (this.primeiroAcessoSelecaoPeriodo) {
      this.carregarTurnos();
      this.carregarParametrosPeriodo();
      // Marca que não é mais o primeiro acesso
      this.primeiroAcessoSelecaoPeriodo = false;
    }

    // Marca que a inicialização foi concluída após o próximo tick
    this.$nextTick(() => {
      this.inicializando = false;
    });
  },
};
</script>
